<template>
  <v-list-item
    v-if="isInClub"
    @click="emit('click')"
  >
    <v-list-item-icon class="my-auto">
      <v-img
        src="/static/_v1/pd/icons/ui-kit/club/club-check.svg"
        width="24"
        height="24"
        :alt="translate('Иконка Галочка Клуба')"
        eager
      />
    </v-list-item-icon>
    <v-list-item-content class="py-2">
      <v-list-item-title class="text-body-1 text--text">
        {{ translate('Клубная карта') }}
      </v-list-item-title>
      <v-list-item-subtitle class="text-body-2 text-info--text">
        {{ cardDateEndLabel }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore } from 'src/store'
import { translate } from 'src/layouts/core-layout/_functions/translate'

const emit = defineEmits(['click'])

const { context }: ContextStore = useContextStore()

const isInClub = Boolean(context.request.user.is_in_club)
const cardDateEnd = context.request.user.club_card?.dt_end || ''
const cardDateEndLabel = computed(() => `${translate('до')} ${cardDateEnd}`)
</script>
